export default "__VITE_ASSET__f265513b__"